import firebase from 'firebase';

export default {
    users: {
        getById: (id) => firebase.firestore().collection('users').doc(id).get(),
        getByInstitution: (id) => firebase.firestore().collection('users').where('institution', '==', id).get()
    },
    institutions: {
        getById: (id) => firebase.firestore().collection('institutions').doc(id).get(),
    },
    sessions: {
        getByInstitution: (id) => firebase.firestore().collection('sessions').where('institution', '==', id).get(),
        getByUserId: (id) => firebase.firestore().collection('sessions').where('userId', '==', id).get()
    }
}